frappe.ready(() => {
    console.log("我是website脚本，执行了。。。。。。")
    // 左侧菜单的选中
    const cur = location.pathname;
    console.log("当前网站的路径：", cur);
    document.querySelectorAll('.web-sidebar a').forEach(a => {
        if (cur.startsWith(a.getAttribute('href'))) {
            a.classList.add('lemon-website-active');
        }
        if(cur === "/" && a.getAttribute('href') === "/web/home") {
            a.classList.add('lemon-website-active');
        }
    });

    // 顶部导航栏的logo
    const logo = $("#lemon-website-logo")
    frappe.call({
        method: "lemon_factory.api.get_website_settings",
        type: "GET"
    }).then(r => {
        const {app_logo, app_name, banner_image} = r.message || {};
        let appLogoDiv = ""
        let appNameDiv = ""
        if(banner_image){
            appLogoDiv = `
                <img width="123" height="26" src="${banner_image}" alt="app logo">
            `
        }else{
            if (app_logo) {
                appLogoDiv = `
                    <img width="32" height="32" src="${app_logo}" alt="app logo">
                `
            }
            if (app_name) {
                appNameDiv = `
                    <span>${app_name}</span>
                `
            }
            if (app_name && app_logo) {
                appLogoDiv = `
                    <img width="32" height="32" src="${app_logo}" alt="app logo">
                `
                appNameDiv = `
                    <span>${app_name}</span>
                `
            }
        }

        if(logo){
            logo.append(`<div class="website-logo">${appLogoDiv}${appNameDiv}</div>`)
        }
    }).catch(err => {
        if (logo) {
            logo.append(`<img width="123" height="26" src='/assets/lemon_factory/images/logo@2x.png'>`)
        }
    })


    // 未登录时隐藏侧边栏
    if (!frappe.session.user || frappe.session.user === "Guest") {
        $(".sidebar-column").hide()
        $(".main-column").css("width", "100%")
    }else {
        $(".sidebar-column").show()
        $(".main-column").css("width", "calc(100% - 220px)")
    }


})
